"use strict";
/**
 * @module Services
 */
Object.defineProperty(exports, "__esModule", { value: true });
var require_non_null_1 = require("./../util/require-non-null");
/**
 * Implementation of {@link ErrorReport}
 */
var ErrorReportImpl = /** @class */ (function () {
    /**
     * Create an error report
     *
     * @param  message  the error message
     * @param  line     the line at which the problem was found
     * @param  column   the column at which the problem was found
     */
    function ErrorReportImpl(message, line, column) {
        this.message = require_non_null_1.requireNonNull(message, 'message');
        this.line = line || 0;
        this.column = column || 0;
    }
    /**
     * Convert object to string
     *
     * @return a string representation of the object
     */
    ErrorReportImpl.prototype.toString = function () {
        return "ErrorReport [" + this.message + " at [" + this.line + ":" + this.column + "]]";
    };
    return ErrorReportImpl;
}());
exports.ErrorReportImpl = ErrorReportImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/error-report.js
// module id = 1545
// module chunks = 1